import { useState } from "react";
import { MdErrorOutline } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom"
import Loading from "../../icons/Loading";
import { post_UserLogin } from "../../services/Login";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import useAuth from "../../hook/useAuth";
import baseURL from "../../config/api";
import { getChildInvitationByUserIdandEmail } from "../../services/Parent";
import { getClassInvitationUserIdandEmail } from "../../services/Class";

export const LoginIn = () => {
    const navigate = useNavigate();
    const { setAuth }: any = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [showError, setShowError] = useState<string>("");
    const [userName, setUserName] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const role = Cookies.get("role-elministry") || "";
    const token = Cookies.get("token-elministry");
    if (token) {
        let navigationLink = "";
        switch (role) {
            case "Admin":
                navigationLink = "/admin/users";
                break;

            case "Contributor":
                navigationLink = "/contributor/dashboard";
                break;

            case "Teacher":
                navigationLink = "/teacher/dashboard";
                break;

            case "Parent":
                navigationLink = "/parent/dashboard";
                break;

            case "Learner":
                navigationLink = "/learner/dashboard";
                break;
        }


        navigate(navigationLink, { replace: true });
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isProcessing) {
            return;
        }
        setIsProcessing(true);

        post_UserLogin({
            userName,
            password
        })
            .then((res) => {
                setIsProcessing(false);
                const jsonData: any = jwtDecode(res);
                const id = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
                const role = jsonData["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
                const givenname = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
                const emailAddress = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];

                let navigationLink = "";
                switch (role) {
                    case "Admin":
                        navigationLink = "/admin/users";
                        break;
                    case "Contributor":
                        navigationLink = "/contributor/dashboard";
                        break;

                    case "Teacher":
                        navigationLink = "/teacher/dashboard";
                        break;

                    case "Parent":
                        navigationLink = "/parent/dashboard";
                        break;

                    case "Learner":
                        navigationLink = "/learner/dashboard";
                        break;
                }



                Cookies.set("token-elministry", res, {
                    expires: jsonData.exp,
                });
                Cookies.set("role-elministry", role, {
                    expires: jsonData.exp,
                });
                Cookies.set("userId-elministry", id, {
                    expires: jsonData.exp,
                })

                setUserName("");
                setPassword("");
                setShowError("");
                getUserData(id, jsonData.exp, navigationLink, role, givenname, emailAddress, res);

            })
            .catch(error => {
                setIsProcessing(false);
                setShowError(error?.response?.data);
                console.log(error);
            });
    }

    const getUserData = (id: string, exp: any, navigationLink: string, role: string, givenname: string, emailAddress: string, token: string) => {
        fetch(`${baseURL}users/${parseInt(id)}`)
            .then((res) => res.json())
            .then((userData) => {
                const profileImg = userData?.profilePic;
                if (role === "Learner") {
                    checkPendingInvitation(id, exp, navigationLink, role, givenname, emailAddress, token, profileImg)
                }
                else {
                    Cookies.set("profileImg-elministry", profileImg, {
                        expires: exp,
                    });
                    setAuth({ id, userName, givenname, emailAddress, role, accessToken: token, profileImage: profileImg });
                    setIsProcessing(false);
                    navigate(navigationLink, { replace: true });
                }

            })
            .catch((error) => {
                setIsProcessing(false);
                console.error(error);
            });
    }

    const checkPendingInvitation = (id: string, exp: any, navigationLink: string, role: string, givenname: string, emailAddress: string, token: string, profileImg: string) => {
        getChildInvitationByUserIdandEmail(id, emailAddress)
            .then((data) => {
                if (data.length > 0) {
                    Cookies.set("profileImg-elministry", profileImg, {
                        expires: exp,
                    });
                    setAuth({ id, userName, givenname, emailAddress, role, accessToken: token, profileImage: profileImg });
                    setIsProcessing(false);
                    navigate(`/child-invitation/${data[0]?.token}`, {
                        state: {
                            invitationData: data[0]
                        }
                    });
                }
                else {
                    getClassInvitationUserIdandEmail(id, emailAddress)
                        .then((data) => {
                            if (data.length > 0) {
                                Cookies.set("profileImg-elministry", profileImg, {
                                    expires: exp,
                                });
                                setAuth({ id, userName, givenname, emailAddress, role, accessToken: token, profileImage: profileImg });
                                setIsProcessing(false);
                                navigate(`/class/${data[0]?.joinCode}`,
                                    {
                                        state: {
                                            invitationData: data[0]
                                        }
                                    }
                                );
                            }
                            else {
                                setAuth({ id, userName, givenname, emailAddress, role, accessToken: token, profileImage: profileImg });
                                setIsProcessing(false);
                                navigate(navigationLink, { replace: true });
                            }
                        })
                        .catch((error) => {
                            Cookies.set("profileImg-elministry", profileImg, {
                                expires: exp,
                            });
                            setAuth({ id, userName, givenname, emailAddress, role, accessToken: token, profileImage: profileImg });
                            setIsProcessing(false);
                            navigate(`/learner/dashboard`, { replace: true });
                            console.error(error);
                        })

                }
            })
            .catch((error) => {

                Cookies.set("profileImg-elministry", profileImg, {
                    expires: exp,
                });
                setAuth({ id, userName, givenname, emailAddress, role, accessToken: token, profileImage: profileImg });
                setIsProcessing(false);
                navigate(`/learner/dashboard`, { replace: true });
                console.error(error);
            })

    }

    return (
        <div className="flex">
            <div className="hidden md:flex w-1/2 px-8">
                <img
                    src="/images/loginImage.jpg"
                    alt="Students"
                    className="w-full"
                />
            </div>

            <div className="flex w-full md:w-1/2 items-start justify-center bg-[#f6f9fc]">
                <div className="w-full px-2 py-4">
                    <div className="flex items-center mb-6 border-b border-[#D0D0D0] ">
                        <span className="font-semibold text-lg">Sunday School</span>
                    </div>

                    <div className="px-20 py-8">
                        <h2 className="text-2xl font-semibold mb-6">Login</h2>

                        <form onSubmit={handleSubmit}>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-xs font-semibold mb-1">User Name*</label>
                                    <input
                                        type="text"
                                        placeholder="User Name"
                                        className="w-full text-gray-600 text-sm bg-secondary border border-[#D0D0D0] rounded-md px-3 py-2 focus:ring-2 focus:ring-primary outline-none"
                                        required
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className="block text-xs font-semibold mb-1">Password*</label>
                                    <div className="relative flex items-center">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password"
                                            className="w-full text-gray-600 text-sm bg-secondary border border-[#D0D0D0] rounded-md px-3 py-2 focus:ring-2 focus:ring-primary outline-none pr-10"
                                            required
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        {
                                            showPassword ? <span className="material-symbols-outlined text-gray-500 absolute right-3 cursor-pointer text-lg" onClick={() => setShowPassword(false)}>
                                                visibility_off
                                            </span> : <span className="material-symbols-outlined text-gray-500 absolute right-3 cursor-pointer text-lg" onClick={() => setShowPassword(true)}>
                                                visibility
                                            </span>
                                        }
                                    </div>
                                </div>

                                <div className="flex justify-end mt-1">
                                    <NavLink
                                        to="/forgot-password"
                                        className="text-xs text-primary hover:underline"
                                    >
                                        Forgot password?
                                    </NavLink>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className={`w-full bg-primary text-white py-2 rounded-[6px] transition mt-10 font-medium ${isProcessing ? "cursor-default" : "cursor-pointer hover:bg-sky-600"}`}
                            >
                                {
                                    isProcessing
                                        ? <>
                                            <Loading />
                                            Processing...
                                        </>
                                        : "Log in"
                                }
                            </button>

                            {showError && (
                                <div className="flex justify-center items-center mt-2 text-xs text-red-500">
                                    <MdErrorOutline className="mr-1" style={{ fontSize: 16 }} />
                                    <span>
                                        {showError}
                                    </span>
                                </div>
                            )}
                        </form>

                        {/* Footer Links */}
                        <p className="mt-6 text-sm text-gray-600 text-center">
                            Don’t have an account?{" "}
                            <NavLink to="/signup" className="text-primary hover:underline">
                                Create an account
                            </NavLink>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}